import { isNumber } from 'lodash';
import React, { FC, useRef, useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { loanDataStore } from 'src/store/housingfunds/loan';
import { dateCalendarFormatType, currentFormatTime, dateFormat } from 'src/utils/dateSet';
import { getMemberInfo } from 'src/utils/common';
import {
  errorModalViewStore,
  loadingModalViewStore,
  confirmModalViewStore,
  contentModalDep2ViewStore,
} from 'src/store/modal';
import { fetchInsertHouseLoan, fetchUpdateHouseLoan } from 'src/fetch/stepC/houseLoan';
import InputBox from 'src/components/atoms/input/DefInputBox';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import LabelSelect from 'src/components/atoms/selectbox/LabelSelect';
import HelpButton from 'src/components/atoms/buttons/HelpButton';
import Description from 'src/components/molecules/table/Description/Donation';
import InputDateBox from 'src/components/atoms/input/InputDateBox';
import {
  settlementNtsDataStore,
  ntsFileDataStore,
  settlementDataStore,
} from 'src/store/settlementInfo';
import { addComma } from 'src/utils/common';

interface Props {
  data: any;
  type: string;
}
const GridAdd: FC<Props> = ({ data, type }) => {
  const userInfoData: any = getMemberInfo();

  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  const setConfirmModalState = confirmModalViewStore((state: any) => state.set);
  const closeModalState = confirmModalViewStore((state: any) => state.close);
  const setContentModalState = contentModalDep2ViewStore((state: any) => state.set);

  const storeData = loanDataStore((state: any) => state.result).data || [];
  const storeInitPayload = loanDataStore((state: any) => state.initPayload);
  const storePayload = loanDataStore((state: any) => state.payload);
  const storePayloadBind = loanDataStore((state: any) => state.bindPayload);
  const bindStoreParam = loanDataStore((state: any) => state.param);
  const bindStoreBindParam = loanDataStore((state: any) => state.bindParam);

  // 정산결과
  const settlementBindParam = settlementDataStore((state: any) => state.bindParam);
  const settlementParam = settlementDataStore((state: any) => state.param);
  // 정산결과(NTS)
  const ntsInfoBindParam = settlementNtsDataStore((state: any) => state.bindParam);
  const ntsInfoParam = settlementNtsDataStore((state: any) => state.param);
  // NTS 업로드파일 데이터
  const ntsFileBindParam = ntsFileDataStore((state: any) => state.bindParam);
  const ntsFileParam = ntsFileDataStore((state: any) => state.param);

  useEffect(() => {
    if (type === 'insert') {
      const dateStr = currentFormatTime('YYYYMMDD');
      storePayloadBind({ ...storeInitPayload, rep_date: dateStr });
    } else {
      const storeData = data;
      for (const key in storePayload) {
        if (storeData) storePayload[key] = storeData[key];
      }
      storePayloadBind({ ...storePayload });
    }
  }, [storeData]);

  const dataTypeSet = [
    { id: '', value: '선택' },
    {
      id: '1',
      value: '10년이상 15년미만',
    },
    {
      id: '2',
      value: '15년이상 30년미만',
    },
    {
      id: '3',
      value: '30년 이상',
    },
  ];
  const checkedDataType =
    storePayload.rep_term === ''
      ? dataTypeSet[0]
      : {
          id: storePayload.rep_term,
          value: dataTypeSet.find((item: any) => item.id === storePayload.rep_term)?.value,
        };

  const dataTypeSelect: any = {
    checked: checkedDataType,
    options: dataTypeSet,
  };

  const dataMethodTypeSet = [
    { id: '', value: '선택' },
    {
      id: '1',
      value: '고정금리 또는 비거치식분할상환',
    },
    {
      id: '2',
      value: '고정금리 이면서 비거치식분할상환',
    },
    {
      id: '3',
      value: '기타 대출',
    },
  ];
  const checkedMethod =
    storePayload.rep_term === ''
      ? dataMethodTypeSet[0]
      : {
          id: storePayload.rep_method,
          value: dataMethodTypeSet.find((item: any) => item.id === storePayload.rep_method)?.value,
        };

  const methodSelect: any = {
    checked: checkedMethod,
    options: dataMethodTypeSet,
  };

  const help = {
    content: `
      <div className="_hint_content">
        <div className="_item">ㆍ 정치자금기부금, 고향사랑기부금, 우리사주조합기부금은 본인 지출액만 공제가능합니다.</div>
        <div className="_item">ㆍ 『기부장려금 신청금액』은 기부자의 세액공제 대신 기부금 단체에 환급하기 위해 신청한 금액입니다.</div>
        <div className="_item">ㆍ 금액(국세청·기타)에는 『기부장려금 신청금액』과의 합산이 아닌 제외된 공제대상금액을 입력합니다.</div>
      </div>
      `,
    title: '공제 대상 항목',
  };

  const help_t2 = {
    content: `
      <div className="_hint_content">
        <div className="_item">* 사업자 등록번호(주민등록번호)는 '-'를 제외한 숫자만 입력해야 합니다.</div>
      </div>
      `,
    title: '사업자등록번호',
  };

  const selectUser = {
    checked: { id: '', value: '선택' },
    options: [{ id: '1', value: '고길동' }],
  };
  const selectType = {
    checked: { id: '', value: '선택' },
    options: [
      { id: '1', value: '취학전아동' },
      { id: '2', value: '초중고등학교' },
      { id: '3', value: '중고생 교복비' },
      { id: '4', value: '대학교(대학원 불포함)' },
      { id: '5', value: '본인(대학원 등)' },
      { id: '5', value: '장애인 특수교육비' },
      { id: '5', value: '초중고 체험 학습비' },
      { id: '5', value: '학자금대출 상환액' },
      { id: '5', value: '대학입학 전형료, 수능응시료' },
    ],
  };
  const confirmSelect = (item: any, field: string) => {
    if (field === 'family_seqid') {
      storePayloadBind({ ...storeInitPayload, family_seqid: item.id, name: item.value });
    } else {
      storePayload[field] = item.id;
      storePayloadBind({ ...storePayload });
    }
  };

  const confirmEvt = () => {
    storePayload.acct_year = userInfoData.acct_year;
    storePayload.co_cd = userInfoData.co_cd;
    storePayload.co_id = userInfoData.co_id;
    const param: any = storePayload;

    // return false;
    fetchInsertHouseLoan(param, queryClient, errorModalState, loadingState, () => {
      const initialSeq = bindStoreParam.initialSeq || 0;
      bindStoreBindParam({ initialSeq: initialSeq + 1 });

      const initialSetSeq = settlementParam.initialSeq || 0;
      settlementBindParam({ initialSeq: initialSetSeq + 1 });
      const initialNtsSeq = ntsInfoParam.initialSeq || 0;
      ntsInfoBindParam({ initialSeq: initialNtsSeq + 1 });
      const initialFileSeq = ntsFileParam.initialSeq || 0;
      ntsFileBindParam({ initialSeq: initialFileSeq + 1 });

      setContentModalState({
        active: '',
      });
    });
  };

  // UPDATE
  const modifyEvt = () => {
    storePayload.acct_year = userInfoData.acct_year;
    storePayload.co_cd = userInfoData.co_cd;
    storePayload.co_id = userInfoData.co_id;
    const param: any = storePayload;
    console.log('confirmEvt:update::', param);
    // return false;
    fetchUpdateHouseLoan(param, queryClient, errorModalState, loadingState, () => {
      const initialSeq = bindStoreParam.initialSeq || 0;
      bindStoreBindParam({ initialSeq: initialSeq + 1 });

      const initialSetSeq = settlementParam.initialSeq || 0;
      settlementBindParam({ initialSeq: initialSetSeq + 1 });
      const initialNtsSeq = ntsInfoParam.initialSeq || 0;
      ntsInfoBindParam({ initialSeq: initialNtsSeq + 1 });
      const initialFileSeq = ntsFileParam.initialSeq || 0;
      ntsFileBindParam({ initialSeq: initialFileSeq + 1 });

      setContentModalState({
        active: '',
      });
    });
  };

  const checkClickEvt = (e: React.MouseEvent, type: string) => {
    let useYN = true;
    if (type === 'on') useYN = false;
    // setInpState({ ...inpState, hometaxYN: { value: useYN } });
  };

  const inpStrChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const chkValue = e.target?.value || '';
    storePayload[key] = chkValue;
    storePayloadBind({ ...storePayload });
  };
  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    let chkValue = e.target?.value || '';
    chkValue = chkValue.replaceAll(',', '');
    const chkNum = Number(chkValue);
    if (chkNum || chkNum === 0) {
      storePayload[key] = chkNum;
      storePayloadBind({ ...storePayload });
    }
  };
  const calendarStartRef = useRef<HTMLInputElement | null>(null);
  const calendarStartEvt = (date: string) => {
    const dateStr = dateFormat(date, 'YYYYMMDD');
    storePayload.rep_date = dateStr;
    storePayloadBind({ ...storePayload });
  };

  return (
    <div className="_add_credit_layout">
      {/* <div className="_desc_div">
        <div className="_main">총 급여의 25% : 10,000,000</div>
        <div className="_sub">신용카드등은 총급여의 25% 이상이어야 공제 가능합니다.</div>
      </div> */}
      <div className="_title_div">
        <div className="_title">공제 대상 항목</div>
        <div className="_help_div">
          <HelpButton content={help.content} title={help.title} styleDef={{ width: '660px' }} />
        </div>
      </div>
      <div className="_inp_div">
        <div className="_opt_div">
          <div className="_item" style={{ zIndex: 20, width: '450px' }}>
            <LabelSelect
              label="상환기간"
              select={dataTypeSelect}
              labelStyle={{ width: '200px' }}
              boxStyleDef={{ width: 'calc(100% - 200px)' }}
              confirmEvent={confirmSelect}
              field="rep_term"
            />
          </div>
          <div className="_item" style={{ zIndex: 15, width: '450px' }}>
            <LabelSelect
              label="상환방식"
              select={methodSelect}
              labelStyle={{ width: '200px' }}
              boxStyleDef={{ width: 'calc(100% - 200px)' }}
              confirmEvent={confirmSelect}
              field="rep_method"
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpStrChangeEvt(e, 'bank_cd')}
              label="금융사"
              status={''}
              labelPosition="left"
              value={storePayload.bank_cd}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'htx_amt')}
              // inputRef={inpRef}
              label="금액(국세청)"
              status={''}
              labelPosition="left"
              value={addComma(storePayload.htx_amt)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'amt')}
              // inputRef={inpRef}
              label="금액(기타)"
              status={''}
              labelPosition="left"
              value={addComma(storePayload.amt)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputDateBox
              inpRef={calendarStartRef}
              value={currentFormatTime('YYYY.MM.DD')}
              status=""
              direction="left"
              placeholder=""
              label="차입일"
              labelPosition="left"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              styleDef={{
                width: 'calc(100% - 200px)',
                fontSize: '14px',
                fontWeight: '500',
              }}
              clickCalendarEvt={calendarStartEvt}
            />
          </div>
        </div>
      </div>
      <div className="_description">
        <Description />
      </div>
      <div className="_btn_div">
        {type === 'insert' ? (
          <DefaultButton
            text="내역 추가"
            styleDef={{ width: '250px' }}
            clickEvent={e => confirmEvt()}
            icon=""
            type="type5"
          />
        ) : (
          <DefaultButton
            text="내역 변경"
            styleDef={{ width: '250px' }}
            clickEvent={e => modifyEvt()}
            icon=""
            type="type3"
          />
        )}
      </div>
    </div>
  );
};

export default GridAdd;
